import React from "react"
import styled from "styled-components"
import Content from "components/Content"
import Product from "./"
import { themeResolver } from "utils/themeResolver"

const StyledProductGrid = styled.section`
  padding: 2rem;
  position: relative;

  .content {
    padding: 0;
    max-width: 60rem;
    margin: 0 auto 4rem;
    position: relative;
    z-index: 100;

    h2 {
      text-transform: uppercase;
    }
  }

  ${(props) => props.theme.media.tablet_landscape_up`
    padding: 4rem 2rem 8rem;
    .content {
      text-align: center;
    }
  `}
`

const StyledProducts = styled.div`
  ${(props) => props.theme.media.tablet_landscape_up`
    display: grid;
    grid-template-columns: repeat(${props.columns}, 1fr);
    grid-column-gap: 4rem;
    grid-row-gap: 4rem;
    max-width: 120rem;
    margin: 0 auto;
    position: relative;
    z-index: 100;
  `}
`

function ProductGrid({
  products,
  content: {
    product_grid_columns,
    product_grid_content,
    product_grid_title,
    product_theme,
  },
  ...props
}) {
  const resolved_theme = themeResolver(product_theme)
  return (
    <StyledProductGrid product_theme={resolved_theme}>
      <article className="content">
        <Content content={product_grid_title} />
        <Content content={product_grid_content} />
      </article>
      <StyledProducts columns={product_grid_columns}>
        {products.map(({ display_style, product }) => (
          <Product
            key={product._meta.id}
            display_style={display_style ? "horizontal" : "vertical"}
            columns={product_grid_columns}
            product_theme={resolved_theme}
            {...product}
          />
        ))}
      </StyledProducts>
    </StyledProductGrid>
  )
}

export default ProductGrid

ProductGrid.defaultProps = {}
ProductGrid.propTypes = {}
